import { createContext, Dispatch, SetStateAction, useMemo, useState } from 'react';

export const LiveActionsDisabledContext = createContext({
  arrowKeyIsDisabled: {} as boolean,
  setArrowKeyIsDisabled: {} as Dispatch<SetStateAction<boolean>>,
  showMediaIsDisabled: {} as boolean,
  setShowMediaIsDisabled: {} as Dispatch<SetStateAction<boolean>>,
});

const LiveActionsDisabledProvider = ({ children }: { children: React.ReactNode }) => {
  const [arrowKeyIsDisabled, setArrowKeyIsDisabled] = useState(false);
  const [showMediaIsDisabled, setShowMediaIsDisabled] = useState(false);
  const value = useMemo(
    () => ({
      arrowKeyIsDisabled,
      setArrowKeyIsDisabled,
      setShowMediaIsDisabled,
      showMediaIsDisabled,
    }),
    [arrowKeyIsDisabled, showMediaIsDisabled],
  );
  return (
    <LiveActionsDisabledContext.Provider value={value}>
      {children}
    </LiveActionsDisabledContext.Provider>
  );
};

export default LiveActionsDisabledProvider;
